import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class GoalService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    saveGoal(goal: any) {
      return this.http.post(this.config.apiUrl +'goal/create', goal, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllGoal(filter:any) {
        return this.http.post(this.config.apiUrl +'goal/get-all',filter, this.setHeaders()).map((response: Response) => response.json());
    }
    deleteGoal(id: any) {
         return this.http.post(this.config.apiUrl +'goal/delete',id, this.setHeaders()).map((response: Response) => response.json());
    }
    updateGoal(request) {
        return this.http.post(this.config.apiUrl +'goal/update',request, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/goal.service.ts